import { Button } from "reactstrap";
import { Modal } from "react-bootstrap";
import React from "react";
import Select from "react-select";

const MultipleSelectRecharge = (props) => {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={true}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Status"
            onChange={props.handleChange}
            options={props.options}
            value={props.selectedOption}
          />
        </div>
        {/* <div style={{ marginBottom: 15 }}>
          <Select
            closeMenuOnSelect={true}
            isMulti
            placeholder="Type"
            onChange={props.handleChange1}
            options={props.options1}
            value={props.selectedOption1}
          />
        </div> */}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary" color="primary" onClick={props.statusFilter}>
          Save{" "}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MultipleSelectRecharge;
